import scheduleList from './shedule-list/ScheduleList.vue'
import scheduleRangeService from '../../services/scheduleRange/ScheduleRange'
import i18n from "../../i18n/index";

export default {
    data() {
        return {
            rules: { required: value => !!value || i18n.t('field-required') },
            updateAction: false,
            title: '',
            btnAction: '',
            dataPickerStart: false,
            dataPickerEnd: false,
            hideList: false,
            validForm: true,
            dataForm: {},
            active: '',
            chkScheduleRange: false,
            loadingDelete: false,
            loadingSaveButton: false,
            showAdd: true,
            showIcon: false,
            showUpdate: false,
            showDelete: false
        }
    },
    components: { scheduleList },
    methods: {
        save() {
            this.loadingDelete = false;
            if (!this.$refs.branchForm.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }

            let data = {
                start: this.dataForm.start,
                end: this.dataForm.end,
                id: this.dataForm.id,
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            scheduleRangeService.createScheduleRanges(data)
                .then(resp => {
                    this.$refs.scheduleList.getScheduleRange();
                    this.loadingSaveButton = false;
                    this.closeScheduleRange();
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: i18n.t('record-successfully-created')
                    });
                }).catch(error => {});
        },
        deteleScheduleRange() {

            let data = { id: this.dataForm.id };
            this.loadingDelete = true;
            scheduleRangeService.deleteScheduleRanges(data).then(result => {
                if (result.status == 200) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Franja horaria Eliminada'
                    });
                    this.$refs.scheduleList.getScheduleRange();
                    this.closeScheduleRange();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error == 'Schedule has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: i18n.t("scheduleRange.has-transactions")
                        })
                    }
                }
                this.$refs.scheduleList.getScheduleRange();
                this.closeScheduleRange();
            });
        },
        updateScheduleRange() {
            let scheduleRangeId = this.dataForm.id;
            this.dataForm.active = this.chkScheduleRange;
            let data = {
                start: this.dataForm.start,
                end: this.dataForm.end,
                active: this.dataForm.active == true ? 1 : 0,
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            scheduleRangeService.updateScheduleRanges(scheduleRangeId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 200) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Franja horaria Actualizada"
                    });
                    this.$refs.scheduleList.getScheduleRange();
                    this.closeScheduleRange();
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'Schedule has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "La franja tiene pendientes"
                        })
                    }
                }
                this.$refs.scheduleList.getScheduleRange();
                this.closeScheduleRange();
            });
        },
        handleSheduleRange(item) {
            this.hideList = true;
            this.title = i18n.t('scheduleRange.update-schedule-title');
            this.btnAction = i18n.t('scheduleRange.update');
            this.dataForm = item;
            this.updateAction = true;
            this.chkScheduleRange = item.active;
            this.showAdd = false;
            this.showUpdate = true;
            this.showDelete = true;
        },
        closeScheduleRange() {
            this.hideList = false;
            this.title = i18n.t('scheduleRange.create-schedule-title')
            this.btnAction = i18n.t('scheduleRange.create')
            this.dataForm = {
                start: null,
                end: null,
                status: null,
                id: null,
                active: ''
            };
            this.updateAction = false;
            this.showAdd = true;
            this.showUpdate = false;
            this.showIcon = false;
            this.showDelete = false;
        }
    },
    mounted() {
        this.closeScheduleRange();
    }
}